import styled from 'styled-components';
import { AssignmentOutlined } from '@mui/icons-material';

import colors from '../../../../styles/colors';

const StyledContainer = styled.div`
  align-self: center;
  margin: 0 10px;
`;

// Lime on the pale header button measured ~1.2:1; these are icons on a light
// surface, so they take ink like the rest of the header content.
const StyledTaskIcon = styled(AssignmentOutlined)`
  color: ${colors.base.beta};
  width: 18px;
  height: 18px;
`;

export {
  StyledContainer,
  StyledTaskIcon,
};
